import { useCallback, useRef, useState } from "react";
import api from "../api/api";

export default function useUserSearch() {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const debounceRef = useRef(null);

    const search = useCallback((query) => {
        const trimmed = (query || "").trim();
        if (!trimmed) {
            setResults([]);
            return;
        }

        if (debounceRef.current) clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(async () => {
            setLoading(true);
            try {
                const res = await api.searchJudges(trimmed);
                const data = res?.data?.data;
                setResults(Array.isArray(data) ? data : []);
            } catch {
                setResults([]);
            } finally {
                setLoading(false);
            }
        }, 300);
    }, []);

    const clearResults = useCallback(() => {
        setResults([]);
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }
        setLoading(false);
    }, []);

    return { search, results, loading, clearResults };
}
